<template>
  <div id = "countdown">
    <div class = "countTitle">Timp rămas pentru a aplica</div>
    <div class = "timecase">
      <div class = "block">
        <hr class = "line">
        <div class = "case">
          <p class = "digit"> {{days}} </p>
          <p class = "text"> {{$t('countdown.dz')}} </p>
        </div>
        <hr class = "line">
      </div>
      <div class = "block">
        <hr class = "line">
        <div class = "case">
          <p class = "digit"> {{hours}} </p>
          <p class = "text">{{$t('countdown.hrs')}} </p>
        </div>
        <hr class = "line">
      </div>
      <div class = "block">
        <hr class = "line">
        <div class = "case">
          <p class = "digit"> {{minutes}} </p>
          <p class = "text"> {{$t('countdown.min')}} </p>
        </div>
        <hr class = "line">
      </div>
    </div>
  </div>
</template>



<script>
export default {
  props: [
    'ext_date'
  ],
  data() {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      date: Math.trunc(Date.parse(this.ext_date) / 1000)
    }
  },
  computed: {
    seconds () {
      return (this.date - this.now) % 60 > 0 ? (this.date - this.now) % 60 : 0;
    },
    minutes() {
      return Math.trunc((this.date - this.now) / 60) % 60 > 0 ? Math.trunc((this.date - this.now) / 60) % 60 : 0;
    },
    hours() {
      return Math.trunc((this.date - this.now) / 60 / 60) % 24 > 0 ?  Math.trunc((this.date - this.now) / 60 / 60) % 24 : 0;
    },
    days() {
      return Math.trunc((this.date - this.now) / 60 / 60 / 24) > 0 ?  Math.trunc((this.date - this.now) / 60 / 60 / 24) : 0;
    }
  },
  mounted() {
    window.setInterval( () => {
      this.now = Math.trunc( (new Date()).getTime() / 1000 );
    }, 1000);
  },

}
</script>

<style scoped lang="scss">

#countdown {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color:transparent;
  z-index: 3;
  line-height: 1vh;
}

.case {
   display: flex;
}

.line { 
  border-style: 0 solid #EDF6FB;
  height: 1px;
  width:120%;
}

.timecase {
  display: flex;
  justify-content: center;
}

.block{
  display: inline-block;
  margin: 10%;
  margin-top:15%;
  text-align: center;
}

.countTitle {
  font-size: 2.50vh;
  color: #EDF6FB;
  text-align: center;
  font-family: "Acumin Variable Concept";
  margin-bottom: -5vh;
  margin-top:-17%;
  margin-left:1vh;
}

.text {
  color: #EDF6FB;
  font-weight: 700;
  font-size: 4.50vh;
  font-family: "Acumin Variable Concept";
  margin-bottom:-6%;
  margin-top: 10%;
  margin-left:6%;
}

.digit {
  color: #EDF6FB;
  font-size: 4.50vh;
  font-weight: 700;
  margin-bottom:-6%;
  margin-top:10%;
  margin-left:6%;
  font-family: "Acumin Variable Concept";
}

// 4K (3840 x 2160 )
@media only screen and (min-width: 3840px) {
    .line { 
    height: 3px;
  }
  .countTitle {
    margin-top:-5%;
    width: 31vh;
  }
  #countdown {
    margin-left:81%;
    line-height: 3.5vh;
  }
}
// 768p (1366 x 768)
@media only screen and (max-width: 1366px) {
    .line { 
    height: 1px;
  }
  .countTitle {
    margin-bottom: -5vh;
  }
  #countdown {
    line-height: 0vh;
    margin-bottom: -1.5vh;
  }
}

// mobil (1024)
@media only screen and (max-width: 1024px) {
    .line { 
    height: 0.2vh;
    width:130%;
    margin-left:-6%;
  }
  .countTitle {
    margin-bottom: -6.5vh;
    margin-top: -5vh;
    margin-left: 2vw;
    font-weight: 100;
    font-size: 3.5vh;
  }
  #countdown {
    width:100%;
    margin-top: -30vh;
    line-height: 4vh;
  }

  .text {
    color: #EDF6FB;
    font-weight: 700;
    font-size: 5.50vh;
    margin-left:6%
  }

  .digit {
  font-size: 5.50vh;
  font-weight: 700;
  margin-left:6%
  }
  .block{
    display: inline-block;
    margin: 4vw;
    margin-top:7vh;
    text-align: center;
  }
}
</style>